import { FiHome, FiUsers, FiDollarSign } from 'react-icons/fi';
import { BsDoorClosed } from 'react-icons/bs';

const AdminStatisticsCards = ({ stats, isLoading }) => {
  const basicCards = [
    {
      title: 'Total Establecimientos',
      value: stats?.total_establishments || 0,
      icon: FiHome,
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600',
      trend: stats?.establishments_trend
    },
    {
      title: 'Total Usuarios',
      value: stats?.total_users || 0,
      icon: FiUsers,
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600',
      trend: stats?.users_trend
    },
    {
      title: 'Total Habitaciones',
      value: stats?.total_rooms || 0,
      icon: BsDoorClosed,
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600',
      trend: stats?.rooms_trend
    }
  ];

  const subscriptionTypes = [
    {
      name: 'Básico',
      value: stats?.subscription_basic || 0,
      color: 'text-gray-700',
      bgColor: 'bg-gray-50'
    },
    {
      name: 'Profesional',
      value: stats?.subscription_professional || 0,
      color: 'text-yellow-700',
      bgColor: 'bg-yellow-50'
    },
    {
      name: 'Empresarial',
      value: stats?.subscription_enterprise || 0,
      color: 'text-orange-700',
      bgColor: 'bg-orange-50'
    }
  ];

  const totalSubscriptions = subscriptionTypes.reduce((sum, sub) => sum + sub.value, 0);

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="bg-white rounded-lg shadow p-6 animate-pulse">
            <div className="flex items-center">
              <div className="flex-shrink-0 rounded-md p-3 bg-gray-200 w-14 h-14" />
              <div className="ml-4 flex-1">
                <div className="h-4 bg-gray-200 rounded w-24 mb-2" />
                <div className="h-8 bg-gray-200 rounded w-16" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {/* Basic metric cards */}
      {basicCards.map((card, index) => {
        const Icon = card.icon;
        return (
          <div key={index} className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow duration-200 p-6">
            <div className="flex items-center">
              <div className={`flex-shrink-0 rounded-md p-3 ${card.bgColor}`}>
                <Icon className={`h-6 w-6 ${card.iconColor}`} />
              </div>
              <div className="ml-4 flex-1">
                <p className="text-sm font-medium text-gray-600">{card.title}</p>
                <div className="flex items-baseline">
                  <p className="text-2xl font-semibold text-gray-900">
                    {card.value.toLocaleString()}
                  </p>
                </div>
                {card.trend && (
                  <div className={`text-xs mt-1 ${card.trend >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {card.trend >= 0 ? '↑' : '↓'} {Math.abs(card.trend)}% vs mes anterior
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}

      {/* Subscriptions card */}
      <div className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow duration-200 p-6">
        <div className="flex items-center">
          <div className="flex-shrink-0 rounded-md p-3 bg-indigo-100">
            <FiDollarSign className="h-6 w-6 text-indigo-600" />
          </div>
          <div className="ml-4 flex-1">
            <p className="text-sm font-medium text-gray-600">Suscripciones</p>
            <p className="text-2xl font-semibold text-gray-900 mb-2">
              {totalSubscriptions}
            </p>
            <div className="flex items-center gap-2">
              {subscriptionTypes.map((sub, index) => (
                <div key={index} className={`flex items-center gap-1 px-2 py-1 rounded ${sub.bgColor}`}>
                  <span className={`text-xs font-medium ${sub.color}`}>
                    {sub.name}:
                  </span>
                  <span className={`text-xs font-semibold ${sub.color}`}>
                    {sub.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminStatisticsCards;
